import { addDays, format, addWeeks } from 'date-fns';
import { ru } from 'date-fns/locale';

const DATE_FORMAT = 'd MMMM';
const DATE_FORMAT_WITH_YEAR = 'd MMMM yyyy';

export const formatDateWithOffset = (daysToAdd: number, { prefix = '' } = {}): string => {
  const now = new Date();
  const targetDate = addDays(now, daysToAdd);

  const sameYear = now.getFullYear() === targetDate.getFullYear();

  const pattern = sameYear ? DATE_FORMAT : DATE_FORMAT_WITH_YEAR;

  const dateString = format(targetDate, pattern, { locale: ru });

  return prefix ? `${prefix} ${dateString}` : dateString;
};

export const formatNextPaymentDate = ({ prefix = '' } = {}): string => {
  const now = new Date();
  const nextPayment = addWeeks(now, 2);

  const sameYear = now.getFullYear() === nextPayment.getFullYear();
  const pattern = sameYear ? DATE_FORMAT : DATE_FORMAT_WITH_YEAR;

  const dateString = format(nextPayment, pattern, { locale: ru });

  return prefix ? `${prefix} ${dateString}` : dateString;
};
